/* Brenora Ansageleiste (sections/brenora-announcements.liquid).
   Mobil (< 750 px): eine Ansage pro Ansicht, CSS Scroll-Snap, alle n Sekunden weiter, Endlosschleife
   über einen Klon der ersten Ansage. Stopp bei prefers-reduced-motion, Hover, Fokus, Berührung und
   verstecktem Tab. Ab 750 px stehen alle Ansagen nebeneinander, das Modul tut dann nichts. */
const MOBILE = window.matchMedia('(max-width: 749px)');
const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

class BrenoraAnnouncements extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.b-ann__track');
    if (!this.track || this.track.children.length < 2) return;
    this.items = [...this.track.children];
    this.paused = new Set();
    this.controller = new AbortController();
    const { signal } = this.controller;

    // Klon der ersten Ansage am Ende: von der letzten geht es sanft „vorwärts“ zur ersten.
    this.clone = this.items[0].cloneNode(true);
    this.clone.setAttribute('aria-hidden', 'true');
    this.clone.classList.add('b-ann__item--clone');
    this.clone.removeAttribute('data-shopify-editor-block');
    this.clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
    this.track.append(this.clone);

    const pause = (why) => () => { this.paused.add(why); this.stop(); };
    const resume = (why) => () => { this.paused.delete(why); this.start(); };
    this.addEventListener('pointerenter', pause('hover'), { signal });
    this.addEventListener('pointerleave', resume('hover'), { signal });
    this.addEventListener('focusin', pause('focus'), { signal });
    this.addEventListener('focusout', resume('focus'), { signal });
    this.track.addEventListener('touchstart', pause('touch'), { signal, passive: true });
    this.track.addEventListener('touchend', () => { setTimeout(resume('touch'), 1500); }, { signal, passive: true });
    document.addEventListener('visibilitychange', () => (document.hidden ? pause('hidden')() : resume('hidden')()), { signal });
    this.track.addEventListener('scroll', () => this.onScroll(), { signal, passive: true });
    MOBILE.addEventListener('change', () => this.reset(), { signal });
    REDUCED.addEventListener('change', () => this.reset(), { signal });
    // Theme-Editor: ausgewählte Ansage zeigen und dort stehen bleiben
    document.addEventListener('shopify:block:select', (e) => {
      const i = this.items.findIndex((el) => el.contains(e.target) || el === e.target);
      if (i < 0) return;
      this.paused.add('editor');
      this.stop();
      this.go(i, false);
    }, { signal });
    document.addEventListener('shopify:block:deselect', resume('editor'), { signal });

    this.start();
  }

  disconnectedCallback() {
    this.stop();
    this.controller?.abort();
    clearTimeout(this.scrollTimer);
    this.clone?.remove();
  }

  get width() { return this.track.clientWidth || 1; }
  get index() { return Math.round(this.track.scrollLeft / this.width); }

  canRun() {
    return MOBILE.matches && !REDUCED.matches && this.dataset.autoplay !== 'false' && this.paused.size === 0;
  }

  start() {
    this.stop();
    if (!this.canRun()) return;
    const ms = Math.max(2, Number(this.dataset.interval) || 4) * 1000;
    this.timer = setInterval(() => this.go(this.index + 1, true), ms);
  }

  stop() { clearInterval(this.timer); this.timer = null; }

  reset() {
    this.go(0, false);
    this.start();
  }

  go(i, smooth) {
    this.track.scrollTo({ left: i * this.width, behavior: smooth ? 'smooth' : 'instant' });
  }

  // Nach dem Einrasten auf dem Klon (automatisch oder per Wischen) unsichtbar zur echten ersten springen.
  onScroll() {
    clearTimeout(this.scrollTimer);
    this.scrollTimer = setTimeout(() => {
      if (this.index >= this.items.length) this.go(0, false);
    }, 120);
  }
}

if (!customElements.get('brenora-announcements')) customElements.define('brenora-announcements', BrenoraAnnouncements);
